import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  PollResults,
  SetPollAnswer,
} from '../../content/poll/answer_pb';

import {
  PollAnswer as __PollAnswer,
} from '../../content/poll/answer_pb_service';

@Injectable({providedIn: 'root'})
export class PollAnswer {

  constructor(private _ngZone: NgZone) {
  }

  set(request: SetPollAnswer): Promise<PollResults>;
  set(request: SetPollAnswer, metadata: grpc.Metadata): Promise<PollResults>;
  set(request: SetPollAnswer, callback: (err: any|null, response: PollResults, metadata: grpc.Metadata) => void): void;
  set(request: SetPollAnswer, metadata: grpc.Metadata, callback: (err: any|null, response: PollResults, metadata: grpc.Metadata) => void): void;

  set(request: SetPollAnswer, arg1?: grpc.Metadata|((err: any|null, response: PollResults, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: PollResults, metadata: grpc.Metadata) => void): Promise<PollResults>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<PollResults>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PollAnswer.Set, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

